import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "progress", "progressContainer"];

  connect() {
    this.files = {};

    addEventListener("direct-upload:initialize", this.initialize.bind(this));
    addEventListener("direct-upload:start", this.start.bind(this));
    addEventListener("direct-upload:progress", this.progress.bind(this));
    addEventListener("direct-upload:error", this.error.bind(this));
    addEventListener("direct-upload:end", this.end.bind(this));
  }

  disconnect() {
    removeEventListener("direct-upload:initialize", this.initialize.bind(this));
    removeEventListener("direct-upload:start", this.start.bind(this));
    removeEventListener("direct-upload:progress", this.progress.bind(this));
    removeEventListener("direct-upload:error", this.error.bind(this));
    removeEventListener("direct-upload:end", this.end.bind(this));
  }

  initialize(event) {
    if (!event) return;

    const { id } = event.detail;
    this.files[id] = 0;
  }

  start() {
    this.progressContainerTarget.classList.remove("hidden");
  }

  progress(event) {
    const { id, progress } = event.detail;
    this.files[id] = progress;
    this.update();
  }

  error(event) {}

  end() {
    const completed = Object.values(this.files).filter((v) => v == 100);

    if (completed === this.numFiles) {
      this.progressTarget.style.width = "100%";
      this.progressContainerTarget.classList.add("hidden");
    }
  }

  update() {
    const totalProgress = Object.values(this.files).reduce(
      (total, fileProgress) => total + fileProgress
    );
    const numFiles = Object.keys(this.files).length;

    const relativeProgress = Math.floor(
      (totalProgress / (100 * numFiles)) * 100
    );
    this.progressTarget.style.width = `${relativeProgress}%`;
  }

  delete(event) {
    event.preventDefault();
    console.log(event.currentTarget);
    const remove = confirm("Are you sure?");
    if (remove) {
      event.currentTarget.remove();
    }
  }
}
